export class ShowHide {
    static display(el: Element | Element[] | HTMLCollectionOf<Element> | string, showHide: boolean) {
        if (typeof (el) === "string") {
            el = document.getElementById(el.toString());
        }

        if (el == null) return;

        if (showHide) {
            ShowHide.show(el);
        } else {
            ShowHide.hide(el);
        }
    }
    static show(el: Element | Element[] | HTMLCollectionOf<Element> | string): void {
        if (typeof(el) ==="string") {
            el = document.getElementById(el.toString());
        }
        if (el == null) return;

        if (Array.isArray(el)) {
            [].forEach.call(el, (element: HTMLElement) => ShowHide.show(element));
        } else {
            if (el instanceof Element) {
                const htmlEl = el as HTMLElement;

                htmlEl.style.display = "";
                htmlEl.removeAttribute("aria-hidden");
            } else {
                for (let index = 0; index < el.length; index++) {
                    ShowHide.show(el[index]);
                }
            }
        }
    }
    static hide(el: Element | Element[] | HTMLCollectionOf<Element> | string): void {
        if (typeof (el) === "string") {
            el = document.getElementById(el.toString());
        }
        if (el == null) return;

        if (Array.isArray(el)) {
            [].forEach.call(el, (element: HTMLElement) => ShowHide.hide(element));
        } else {
            if (el instanceof Element) {
                const htmlEl = el as HTMLElement;

                htmlEl.style.display = "none";
                htmlEl.setAttribute("aria-hidden", "aria-hidden");
            } else {
                for (let index = 0; index < el.length; index++) {
                    ShowHide.hide(el[index]);
                }
            }
        }
    }
}